import React from 'react'
import { AffiliateWrapper } from '../components/affiliate/styles'
import Hero from '../components/Hero'
import HeroImage from '../../public/affiliate/gs_affiliate_landing.jpg'
import HeaderContent from '../components/affiliate/HeaderContent'
import WhoWeAre from '../components/affiliate/WhoWeAre'
import WhyJoin from '../components/affiliate/WhyJoin'
import Questions from '../components/affiliate/Questions'
import Locations from '../components/events/Locations'
import WhatWereLookingFor from '../components/affiliate/WhatWereLookingFor'
import HowItWorks from '../components/how-it-works'

const Affiliate = () => {
  const handleClick = () =>
    window.open(
      'https://www.shareasale.com/shareasale.cfm?merchantID=138044',
      '_blank',
      'noopener, noreferrer'
    )

  const data = {
    'Apply to join': 'Share your contact information, social handles and why you want to join our program through our portal.',
    'Enjoy free glam': 'Receive complimentary services every month in exchange for content and social posting.',
    'Get insider access': `You'll be first in line for exclusive events, new services, brand partnerships and more.`
  }
  return (
    <AffiliateWrapper>
      <Hero
        className="hero-component"
        image={HeroImage}
        content={<HeaderContent {...{ handleClick }} />}
      />
      <HowItWorks data={data} />
      <WhyJoin {...{ handleClick }} />
      <WhatWereLookingFor />
      <WhoWeAre {...{ handleClick }} />
      <Questions />
      <Locations intro='Our squad currently serves' />
    </AffiliateWrapper>
  )
}

// eslint-disable-next-line no-unused-vars
export async function getServerSideProps(context) {
  return { props: {} }
}

export default Affiliate
